module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/34ycnE/tc-custom/9781610580540.jpg?1725288162605",
      "alt": "This image is the cover for the book 300 15-Minute Low-Carb Recipes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("300 15-Minute Low-Carb Recipes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Simple, super-speedy dinners, desserts, snacks, sides, and more from the million-selling low-carb guru!")]), _c('br'), _c('br'), _vm._v("Eat well, stay fit, and maintain your low-carb diet with these 300 delicious and easy recipes that can be made in fifteen minutes or less from start to finish. Fast cooking methods will lead you to a fabulous finished product every time! Create delicious, nutritious, filling meals and treats like:"), _c('br'), _c('br'), _vm._v("Rosemary-ginger ribs with apricot glaze—Cranberry burgers—Chipotle-bacon breakfast burrito—Chicken chili verde—Beef and bacon “rice” with pine nuts—Thai-style crab salad in avocados—Aladdin salad—Basil-lime shrimp—Salmon in ginger cream—Strawberry ice cream—Mexican chocolate smoothie—and many, many more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dana Carpender\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dana Carpender (Bloomington, Indiana) is a pioneer of the low-carb movement and best-selling author of over 14 cookbooks, including The New 500 Low-Carb Recipes,1001 Low-Carb Recipes, 500 Paleo Recipes, 15-Minute Low-Carb Recipes, The Low-Carb Diabetes Solution Cookbook, 200 Low-Carb, High-Fat Recipes, The Low-Carb Diabetes Solution, The Insulin Resistance Solution, 500 Ketogenic Recipes, and many more. To date, her books have sold over a million copies worldwide. She writes about low-carb cooking and nutrition on her Facebook page, Dana Carpender's Hold the Toast Press.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Fair Winds Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0